var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployee5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E8DB9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1653 23.138H14.2733L13.6293 25H11.5713L15.0853 15.214H17.3673L20.8813 25H18.8093L18.1653 23.138ZM17.6333 21.57L16.2193 17.482L14.8053 21.57H17.6333ZM28.3688 15.228V16.81H24.2948V19.316H27.4168V20.87H24.2948V25H22.3348V15.228H28.3688Z",
    fill: "#E8DB9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee5);
export default __webpack_public_path__ + "static/media/employee5.a4a1465a14412025710e9ec2520bfe1a.svg";
export { ForwardRef as ReactComponent };